// ==================== CHANGE MANAGEMENT ====================

export const CHANGE_MANAGEMENT = {
  stakeholderGroups: [
    {
      group: 'Executive Leadership',
      role: 'Sponsorship and direction',
      engagementStrategy: 'Regular briefings on AI value and progress',
      frequency: 'Monthly',
      champion: 'CEO/CIO',
      keyMessages: ['Strategic importance', 'ROI expectations', 'Risk management']
    },
    {
      group: 'Middle Management',
      role: 'Translation and implementation',
      engagementStrategy: 'Workshops on AI capabilities and implications',
      frequency: 'Quarterly',
      champion: 'Department Heads',
      keyMessages: ['Process changes', 'Team impact', 'Support available']
    },
    {
      group: 'Front-line Employees',
      role: 'Execution and feedback',
      engagementStrategy: 'Training and change champions',
      frequency: 'Ongoing',
      champion: 'Team Leads',
      keyMessages: ['Job security', 'New skills', 'Benefits']
    },
    {
      group: 'IT/Technical Teams',
      role: 'Implementation and support',
      engagementStrategy: 'Technical workshops and hackathons',
      frequency: 'Bi-weekly',
      champion: 'CTO',
      keyMessages: ['Technology stack', 'Best practices', 'Career growth']
    }
  ],
  
  communicationPlan: [
    {
      phase: 'Pre-launch',
      audience: 'All employees',
      message: 'AI vision and benefits',
      channel: 'Town halls, Newsletters',
      timing: '2 weeks before'
    },
    {
      phase: 'Launch',
      audience: 'Affected teams',
      message: 'Process changes and support',
      channel: 'Workshops, 1:1 meetings',
      timing: 'Week 1'
    },
    {
      phase: 'Implementation',
      audience: 'Leadership',
      message: 'Progress and results',
      channel: 'Dashboards, Reports',
      timing: 'Monthly'
    },
    {
      phase: 'Post-implementation',
      audience: 'All stakeholders',
      message: 'Success stories and learnings',
      channel: 'Case studies, Celebrations',
      timing: 'Quarterly'
    }
  ],
  
  trainingPrograms: [
    {
      program: 'AI Literacy',
      audience: 'All employees',
      duration: '2 hours',
      mode: 'Online',
      topics: ['AI basics', 'Use cases', 'Impact on work']
    },
    {
      program: 'Data-Driven Decision Making',
      audience: 'Managers',
      duration: '1 day',
      mode: 'Workshop',
      topics: ['Data interpretation', 'Decision frameworks', 'BI tools']
    },
    {
      program: 'AI Tools and Platforms',
      audience: 'Technical teams',
      duration: '1 week',
      mode: 'Hands-on',
      topics: ['ML platforms', 'Model deployment', 'Monitoring']
    },
    {
      program: 'Change Leadership',
      audience: 'Team leads',
      duration: '2 days',
      mode: 'Workshop',
      topics: ['Change management', 'Team coaching', 'Resistance handling']
    }
  ],
  
  resistanceManagement: [
    {
      type: 'Fear of job loss',
      strategy: 'Emphasize augmentation, not replacement',
      tactics: ['Reskilling programs', 'Career path transparency', 'Success stories']
    },
    {
      type: 'Lack of understanding',
      strategy: 'Education and awareness',
      tactics: ['AI literacy training', 'Demo sessions', 'Q&A forums']
    },
    {
      type: 'Loss of control',
      strategy: 'Involvement in design',
      tactics: ['Co-creation workshops', 'Feedback mechanisms', 'Pilot participation']
    },
    {
      type: 'Increased workload',
      strategy: 'Phased implementation',
      tactics: ['Gradual rollout', 'Support resources', 'Workload adjustment']
    }
  ]
};